import { storyblokInit } from "$lib/storyblok/sdk";
import { getSbApiClient, type SbApiClient } from "$lib/utils/storyblok/api";
import { apiPlugin } from "@storyblok/js";

interface StoryblokConfig {
    accessToken: string;
    editMode: boolean;
    url: URL;
}

export class Storyblok {
    #resolveInit: (() => void) | null = null;
    #initPromise = new Promise<void>((resolve) => {
        this.#resolveInit = resolve;
    });

    #editMode = false;
    #client: SbApiClient | null = null;

    get isInitialized(): Promise<void> {
        return this.#initPromise;
    }

    init({ editMode, accessToken, url }: StoryblokConfig) {
        storyblokInit({
            accessToken,
            use: [apiPlugin],
            apiOptions: {
                region: 'us',
                https: true
            }
        });

        this.#editMode = editMode;
        this.#client = getSbApiClient(fetch, url);

        this.#resolveInit?.();
    }

    get client() {
        if (!this.#client) {
            throw new Error('Storyblok client not initialized');
        }
        return this.#client;
    }

    get editMode() {
        return this.#editMode;
    }
}


export const storyblok = new Storyblok();
